import { render } from "./DraftMessages.vue?vue&type=template&id=7079fa34&scoped=true"
import script from "./DraftMessages.vue?vue&type=script&lang=js"
export * from "./DraftMessages.vue?vue&type=script&lang=js"

import "./DraftMessages.vue?vue&type=style&index=0&id=7079fa34&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7079fa34"]])

export default __exports__